import { batchReplaceSuperElement, batchCreateIntermediarySuperForField } from '@fs/zion-sls'
import { getNextUuid } from '../../../../../../shared/utils/utils'

export const removeElement = ({ key, el }) => ({
  type: 'REMOVE_ELEMENT',
  value: {
    id: key,
    partitionKey: el.partitionKey,
    elementType: el.elementType,
  },
})

export const removeFieldOrEvent = ({ key, el }) => {
  const dispatches = [removeElement({ key, el })]

  if (el.elementType === 'EVENT') {
    const eventTypeField = el?.subElements?.find((se) => se.fieldType === 'EVENT_TYPE')
    if (eventTypeField) {
      dispatches.push(
        removeElement({
          key: eventTypeField.id,
          el: {
            partitionKey: el.partitionKey,
            elementType: eventTypeField.elementType,
          },
        })
      )
    }
  }
  return dispatches
}

export const replaceRelationshipPerson = ({ relationshipField, otherPerson, selectedPersonId, value, order }) => {
  const filtered = relationshipField.superElements?.filter((f) => f.id !== selectedPersonId)

  if (filtered?.length && filtered[0].id !== value.key) {
    return batchReplaceSuperElement({
      newSuperPartitionKey: otherPerson.partitionKey,
      oldSuperPartitionKey: filtered[0].partitionKey,
      subPartitionKey: relationshipField.partitionKey,
      oldSuperId: filtered[0].id,
      newSuperId: otherPerson.id,
      subId: relationshipField.id,
      oldElementType: 'PERSON',
      newElementType: 'PERSON',
      extraArgs: { order },
    })
  }
  return []
}

export const findEditedEventAndSuper = (eventElements, editedEventId, superType) => {
  const editedEvent = eventElements.find((element) => element.id === editedEventId)
  return {
    editedEvent,
    editedSuper:
      superType === 'EVENT' ? editedEvent : editedEvent?.subElements?.find((se) => se.elementType === superType),
  }
}

export const getOrCreateSuperIdFromFormState = ({ values, key, eventToAdd, eventElements, selectedPerson }) => {
  let dispatches = []
  let intermediaryId
  const superType = values[`${key}_superType`]
  const editedEventId = values[`${key}_super`]
  if (!eventToAdd) {
    // If the event wasn't just added, get the information needed to add the new field from the hierarchy
    const editedEvent = eventElements.find((element) => element.id === editedEventId)
    const editedSuper =
      superType === 'EVENT' ? editedEvent : editedEvent?.subElements?.find((se) => se.elementType === superType)
    if (!editedSuper) {
      intermediaryId = getNextUuid()
      dispatches = [
        ...dispatches,
        ...batchCreateIntermediarySuperForField({
          partitionKey: selectedPerson?.partitionKey,
          intermediaryType: superType,
          intermediaryId, // Super of the new field, but sub of the event
          superId: editedEventId,
          superType: 'EVENT',
        }),
      ]
    } else {
      // Add field to existing element
      intermediaryId = editedSuper.id
    }
  } else if (superType === 'DATE') {
    intermediaryId = eventToAdd.dateId
  } else if (superType === 'PLACE') {
    intermediaryId = eventToAdd.placeId
  } else {
    // Add the field directly to the newly added event
    intermediaryId = editedEventId
  }
  return { superId: intermediaryId, superType, dispatches }
}
